import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {AddIcon, EditIcon} from 'rambler-ui'
import {arrayFromTimestamp} from '@rambler-id/input'
import InternalHeader from 'components/InternalHeader'
import ProfileSection from 'components/ProfileSection'
import ProfileItem from 'components/ProfileItem'
import RowButton from 'components/RowButton'
import PersonalIcon from 'components/icons/PersonalIcon'
import genders from 'components/GenderField/genders'
import withGeo from 'models/geo'
import ChangeName from '../ChangeName'
import ChangeBirthday from '../ChangeBirthday'
import ChangeGender from '../ChangeGender'
import ChangeGeo from '../ChangeGeo'
import styles from './styles.css'

class General extends PureComponent {
  static propTypes = {
    display: PropTypes.object,
    profile: PropTypes.object,
    geo: PropTypes.object,
    editable: PropTypes.string,
    inlineError: PropTypes.string,
    setEditable: PropTypes.func.isRequired,
    loadGeoInfo: PropTypes.func.isRequired,
    changeProfile: PropTypes.func.isRequired
  }

  UNSAFE_componentWillMount() {
    this.props.loadGeoInfo(this.props.profile.geoid)
  }

  UNSAFE_componentWillReceiveProps({profile}) {
    if (profile.geoid !== this.props.profile.geoid) {
      this.props.loadGeoInfo(profile.geoid)
    }
  }

  render() {
    const {
      display,
      profile,
      geo,
      inlineError,
      editable,
      setEditable,
      changeProfile
    } = this.props

    const isLoginBySber = this.props.info.socialProfiles.some(
      ({provider, isSelf}) => provider === 'sberbank' && !!isSelf
    )

    const genderName = genders[profile.gender]
    const date = arrayFromTimestamp(profile.birthdate)
    const geoName = geo.cache[profile.geoid]

    const shouldShowName =
      !isLoginBySber || (isLoginBySber && display.displayName)

    const shouldShowBirthday = !isLoginBySber || (isLoginBySber && !!date[0])
    const shouldShowGender = !isLoginBySber || (isLoginBySber && !!genderName)

    return (
      <ProfileSection section="general" color="#ec407a" icon={<PersonalIcon />}>
        <InternalHeader>
          <h2>Личные данные</h2>
          <p>
            Поддерживайте информацию о себе в актуальном состоянии и не
            беспокойтесь о ее безопасности. Ваши личные данные надежно
            защищаются Рамблером в соответствии с &laquo;
            <a
              href="https://help.rambler.ru/legal/1142/"
              target="_blank"
              rel="noopener noreferrer">
              Регламентом защиты информации о пользователях
            </a>
            &raquo;.
          </p>
        </InternalHeader>
        {editable === 'name' ? (
          <ChangeName
            initialValues={{
              firstname: profile.firstname,
              lastname: profile.lastname
            }}
            buttonTooltip={inlineError}
            onSubmit={changeProfile}
            onClose={() => setEditable(null)}
          />
        ) : (
          shouldShowName && (
            <ProfileItem
              rightIcon={
                !isLoginBySber && (
                  <RowButton
                    label={`${
                      display.displayName ? 'Изменить' : 'Указать'
                    } имя и фамилию`}
                    onClick={() => setEditable('name')}>
                    {display.displayName ? <EditIcon /> : <AddIcon />}
                  </RowButton>
                )
              }>
              {display.displayName ? (
                <span
                  className={!isLoginBySber && styles.editable}
                  onClick={
                    isLoginBySber ? undefined : () => setEditable('name')
                  }
                  role="none">
                  {display.displayName}
                </span>
              ) : (
                <button
                  type="button"
                  data-anchor
                  tabIndex="0"
                  onClick={() => setEditable('name')}>
                  Указать имя и фамилию
                </button>
              )}
            </ProfileItem>
          )
        )}
        {editable === 'birthday' ? (
          <ChangeBirthday
            initialValues={{
              birthday: date
            }}
            buttonTooltip={inlineError}
            onSubmit={changeProfile}
            onClose={() => setEditable(null)}
          />
        ) : (
          shouldShowBirthday && (
            <ProfileItem
              rightIcon={
                !isLoginBySber && (
                  <RowButton
                    label={`${date[0] ? 'Изменить' : 'Указать'} дату рождения`}
                    onClick={() => setEditable('birthday')}>
                    {date[0] ? <EditIcon /> : <AddIcon />}
                  </RowButton>
                )
              }>
              {date[0] ? (
                <span
                  className={!isLoginBySber && styles.editable}
                  onClick={
                    isLoginBySber ? undefined : () => setEditable('birthday')
                  }
                  role="none">
                  {new Date(profile.birthdate * 1e3).toLocaleDateString(
                    'ru-RU',
                    {
                      timeZone: 'UTC'
                    }
                  )}
                </span>
              ) : (
                <button
                  type="button"
                  data-anchor
                  tabIndex="0"
                  onClick={() => setEditable('birthday')}>
                  Указать дату рождения
                </button>
              )}
            </ProfileItem>
          )
        )}
        {editable === 'gender' ? (
          <ChangeGender
            initialValues={{
              gender: profile.gender || 'u'
            }}
            buttonTooltip={inlineError}
            onSubmit={changeProfile}
            onClose={() => setEditable(null)}
          />
        ) : (
          shouldShowGender && (
            <ProfileItem
              rightIcon={
                !isLoginBySber && (
                  <RowButton
                    label={`${genderName ? 'Изменить' : 'Указать'} пол`}
                    onClick={() => setEditable('gender')}>
                    {genderName ? <EditIcon /> : <AddIcon />}
                  </RowButton>
                )
              }>
              {genderName ? (
                <span
                  className={!isLoginBySber && styles.editable}
                  onClick={
                    isLoginBySber ? undefined : () => setEditable('gender')
                  }
                  role="none">
                  {genderName}
                </span>
              ) : (
                <button
                  type="button"
                  data-anchor
                  tabIndex="0"
                  onClick={() => setEditable('gender')}>
                  Указать пол
                </button>
              )}
            </ProfileItem>
          )
        )}
        {editable === 'geo' ? (
          <ChangeGeo
            initialValues={{
              geoid: profile.geoid
            }}
            buttonTooltip={inlineError}
            onSubmit={changeProfile}
            onClose={() => setEditable(null)}
          />
        ) : (
          <ProfileItem
            rightIcon={
              <RowButton
                label={`${geoName ? 'Изменить' : 'Указать'} населенный пункт`}
                onClick={() => setEditable('geo')}>
                {geoName ? <EditIcon /> : <AddIcon />}
              </RowButton>
            }>
            {geoName ? (
              <span
                className={styles.editable}
                onClick={() => setEditable('geo')}
                role="none">
                {geoName}
              </span>
            ) : (
              <button
                type="button"
                data-anchor
                tabIndex="0"
                onClick={() => setEditable('geo')}>
                Указать населенный пункт
              </button>
            )}
          </ProfileItem>
        )}
      </ProfileSection>
    )
  }
}

export default withGeo(General)
